/* AUTO-GENERATED by scripts/merge-port-additions.mjs — screen-port strings.
   English is the primary language; FA entries are best-effort and admin-managed
   translations replace this mechanism later. */
export const I18N_ADDITIONS = {
  en: {
  "salon": "Salon",
  "kmAway": "{n} km away",
  "cityKmAway": "{city} · {n} km away",
  "locationHidden": "Location hidden",
  "giftAfterMatch": "Send a gift from chat once you match",
  "matchPct": "{n}% match",
  "onlineNow": "online now",
  "deckEmptyTitle": "Deck empty",
  "deckEmptyNote": "Tonight's Salon refills at 20:00.",
  "deckReset": "Reset deck",
  "salonEyebrow": "Tonight's Salon",
  "salonTitle1": "Seven people,",
  "salonTitle2": "chosen for you.",
  "salonSub": "No endless swiping — a daily curated set.",
  "salonResets": "Resets in {time}",
  "salonMore": "+{n} more",
  "salonUnlock": "unlock at 20:00",
  "salonBlack": "FLM Black",
  "salonBlackBody": "See all seven now, plus who chose you.",
  "orbitTap": "Tap someone in your orbit",
  "mutual": "It's mutual",
  "sayHiFirst": "Say hi first",
  "sendRose": "Send a rose · 0.5 TON",
  "matchIcebreaker": "Their icebreaker · guess the lie",
  "matchSharedTastes": "You both like",
  "matchBreakIce": "Break the ice · their tastes",
  "promptQuote": "\"I speak 4 languages, I've run a marathon, I hate coffee.\"",
  "promptOpt1": "4 languages",
  "promptOpt2": "Marathon",
  "promptOpt3": "Hates coffee",
  "likesTitle1": "{n} people",
  "likesTitle2": "chose you.",
  "likesSub": "{n} revealed free today · the rest is FLM Black",
  "likedYouTab": "Liked you · {n}",
  "favoritesTab": "Favorites · {n}",
  "rosesTab": "Roses · {n}",
  "blackBadge": "Black",
  "revealAllCta": "Reveal all {n} — 5 TON / mo",
  "detailPrompt": "Two truths & a lie — guess it",
  "tastesShared": "Tastes · {n} shared",
  "giftsReceived": "Gifts received",
  "giftedTop": "Top 5% gifted this week",
  "block": "Block",
  "report": "Report",
  "shareProfile": "Share profile",
  "photos": "Photos",
  "photoCover": "Cover",
  "closePhoto": "Close",
  "prevPhoto": "Previous photo",
  "nextPhoto": "Next photo",
  "mapTab": "Map",
  "eventsTab": "Events",
  "cityName": "Lisbon",
  "mapNearby": "{city} · {n} nearby",
  "ghostOff": "Ghost off",
  "ghostOn": "Ghost on",
  "ghostHint": "Ghost mode — you browse the map unseen",
  "crossedToday": "Crossed paths today",
  "nNew": "{n} new",
  "crossedWhere": "You both were at {place} · {time}",
  "crossedPlace": "Café Janis",
  "eventsEyebrow": "IRL · {city}",
  "eventsTitle": "Meet off-screen.",
  "eventsSub": "Member events · RSVP with TON, refunded on arrival",
  "hostEvent": "Host your own event",
  "evTagOpen": "Open night",
  "evTagMixer": "Mixer",
  "evTagBlack": "FLM Black only",
  "membership": "Membership",
  "plansHero1": "Date like it's",
  "plansHero2": "by invitation.",
  "inStars": "Stars",
  "inTon": "TON",
  "inUsd": "≈ USD",
  "goPlan": "Go {plan}",
  "payRail": "Pay with TON · USDT · BTC · ETH · Telegram Stars",
  "mostChosen": "Most chosen",
  "savePct": "Save {pct}%",
  "billMonthly": "Monthly",
  "billYearly": "Yearly",
  "mo": "mo",
  "yr": "yr",
  "perYear": "1 year",
  "perMonth": "1 month",
  "upgradeLabel": "Upgrade",
  "upgradeTo": "Upgrade to {plan}",
  "renewHero1": "Your membership,",
  "renewHero2": "renew or level up.",
  "topTierNote": "You're on the top tier — renew anytime above.",
  "perkFreeLikes": "30 likes a day",
  "perkFreeSpark": "1 Spark a day",
  "perkFreeMatch": "Match & chat free",
  "unlockPlan": "Unlock {plan}",
  "orStars": "or {n} ★ Stars",
  "whatChanges": "What changes",
  "freeTier": "Free",
  "cmpLikes": "Daily likes",
  "cancelNote": "Cancel anytime · on-chain receipts in your wallet",
  "payTon": "TON · Tonkeeper",
  "subTon": "TON Connect · UQB7…kT3v · balance 8.2 TON",
  "subStars": "{n} ★ · pay inside Telegram",
  "subUsdt": "TRC-20 / TON Jetton",
  "subBtc": "Lightning",
  "subEth": "Mainnet",
  "confirmTonkeeper": "Confirm in Tonkeeper",
  "payWithStars": "Pay with Telegram Stars",
  "payAmount": "Pay {amt} {coin}",
  "payViaLightning": "Pay via Lightning",
  "qrNote": "Or scan to pay from any wallet — confirmation lands in chat via {bot}.",
  "connectWallet": "Connect wallet",
  "payTonAmount": "Pay {amt} TON",
  "tonConnectHint": "Connect your TON wallet to pay in-app — Tonkeeper, Wallet in Telegram & more.",
  "tonWalletLinked": "Wallet connected — confirm the payment in your wallet.",
  "payManually": "Scan QR · pay manually",
  "qrScanHint": "Scan with any TON wallet, or copy the address. It confirms automatically.",
  "payCancelled": "Payment cancelled — try again.",
  "nonCustodial": "Non-custodial · smart-contract sub, revoke anytime",
  "hubProfileComplete": "Profile {pct}% complete",
  "hubStatLikes": "likes",
  "hubStatMatches": "matches",
  "hubStatGifts": "gifts",
  "hubPremiumName": "Premium",
  "hubPremiumSub": "See who likes you · pay in TON",
  "hubGoPremium": "Go Premium",
  "hubGoPremiumSub": "See who likes you, unlimited likes & more",
  "hubFromTon": "from {n} TON",
  "hubPremiumActive": "Active",
  "premiumBadge": "Premium",
  "premiumBadgeFallback": "PREMIUM",
  "comingSoon": "Coming soon",
  "mpEyebrow": "Membership",
  "mpTitlePremium": "Your membership",
  "mpTitleFree": "Go Premium",
  "mpStatusActive": "Active",
  "mpDaysLeft": "{n} days left",
  "mpDayLeft": "1 day left",
  "mpExpires": "Renews {date}",
  "mpExpiresFree": "No active plan",
  "mpPerksTitle": "What you get",
  "mpLimitsTitle": "Your limits",
  "mpFreeSub": "Unlock unlimited likes, see who likes you, and more.",
  "mpUnlimited": "Unlimited",
  "mpLikesUnlimited": "Unlimited likes",
  "mpLikesFree": "{n} likes/day",
  "mpMessagesUnlimited": "Unlimited messages",
  "mpMessagesFree": "{n} messages/day",
  "mpSuperLikesUnlimited": "Unlimited Sparks",
  "mpSuperLikesFree": "{n} Spark/day",
  "mpSeeLikers": "See who likes you",
  "mpSeeLikersFree": "Likes hidden until you match",
  "mpRewind": "Rewind your last swipe",
  "mpRewindFree": "No Rewind",
  "mpBoost": "{n}-min Boosts",
  "mpRenew": "Renew / Extend",
  "mpUpgrade": "Go Premium",
  "mpUpgradeHigher": "Upgrade to a higher tier",
  "hubEditPhotos": "Edit photos & voice",
  "hubEditPhotosSub": "{n} photos · voice intro on",
  "hubVerification": "Verification",
  "hubVerificationSub": "Face check passed",
  "hubPrivacy": "Privacy & ghost mode",
  "hubPrivacySub": "Visible to matches only",
  "hubLanguageSub": "English · فارسی available",
  "hubWalletSub": "TON Connect · UQ…x4F2",
  "hubTon": "{n} TON",
  "messages": "Messages",
  "typing": "typing…",
  "onlineMatch": "online · {pct}% match",
  "icebreakerGuessed": "Icebreaker · you guessed the lie",
  "ibOptLanguages": "4 languages",
  "ibOptMarathon": "Marathon",
  "ibOptCoffee": "Hates coffee",
  "ibCorrect": "Correct — they actually love coffee. +1 spark ⚡",
  "giftSentName": "{gift} sent",
  "tonOnChain": "{amount} TON · on-chain",
  "seen": "seen",
  "giftsEyebrow": "Gifts · on-chain",
  "giftShopTitle": "Say it with TON.",
  "giftShopSub": "Collectible gifts minted to their wallet — they keep them forever.",
  "sendingTo": "Sending {gift} to {name}",
  "mintedNote": "minted as NFT · message attached",
  "send": "Send",
  "giftRose": "Rose",
  "giftChampagne": "Champagne",
  "giftDiamond": "Diamond",
  "giftMeteor": "Meteor",
  "tipTon": "tip TON",
  "pollTitle": "{name} started a poll",
  "pollSub": "\"first date: gallery or street food?\" · vote to reveal theirs",
  "hubBoost": "Boost",
  "hubBoostSub": "Be seen first for 30 minutes",
  "hubBoostActiveSub": "You're at the front of the deck",
  "hubBoostActive": "Active",
  "hubBoostUntil": "Boosted — seen first until {time}",
  "boostBuyEyebrow": "Boost",
  "boostBuyTitle": "Jump to the front",
  "boostBuySub": "Surface at the top of everyone's deck for 30 minutes — a one-time boost, not a subscription.",
  "hubBoostFreeLeft": "{n} of {m} free boosts left · resets {when}",
  "hubBoostNoneLeft": "Free boosts used up · resets {when}",
  "hubBoostResetDays": "in {n} days",
  "hubBoostResetDay": "tomorrow",
  "hubBoostResetDate": "on {date}",
  "boostBuyOrWait": "Out of free boosts — buy one now, or wait until they reset {when}.",
  "rewind": "Rewind",
  "rewindNothing": "Nothing to undo",
  "rewindMatched": "You matched — can't undo",
  "sparksLeft": "{n} Sparks left",
  "likesLeft": "{n} likes left today",
  "likesUnlimited": "Unlimited likes",
  "limitBackIn": "back in {t}",
  "limitSoon": "back any moment",
  "dailyTitle": "Daily reward",
  "dailyStreakN": "{n}-day streak",
  "dailyClaim": "Claim",
  "dailyNextIn": "next in {t}",
  "dailySparksReward": "+{n} spark",
  "dailyLikesReward": "+{n} likes",
  "inviteTitle": "Invite & earn",
  "inviteSub": "You + your friend each get {n} sparks when they join",
  "inviteSubPremium": "You + your friend each get {n} days of {plan} when they join",
  "inviteStats": "{a} invited · {b} joined",
  "inviteShare": "Invite",
  "inviteShareText": "Join me on FLM 💘 — free dating on Telegram",
  "rewardPremium": "{n} days of {plan} unlocked!",
  "rewardSparks": "{n} free sparks!",
  "rewardPremiumSub": "Your premium perks are live — enjoy.",
  "rewardSparksSub": "Go send some sparks.",
  "rewardTrialTag": "Welcome gift",
  "rewardInviteTag": "Invite reward",
  "rewardCta": "Let's go",
  "outOfLikes": "You're out of likes today — upgrade for more",
  "outOfSparks": "You're out of Sparks today — upgrade for more",
  "msgSent": "Sent",
  "msgDelivered": "Delivered",
  "msgRead": "Read",
  "aboutYou": "About you",
  "aboutYouSub": "All optional — fill what you want others to know.",
  "attrHeight": "Height",
  "attrWeight": "Weight",
  "attrHeightPh": "cm",
  "attrWeightPh": "kg",
  "attrUnitCm": "cm",
  "attrUnitKg": "kg",
  "attrBodyType": "Body type",
  "attrSmoking": "Smoking",
  "attrDrinking": "Drinking",
  "attrExercise": "Exercise",
  "attrDiet": "Diet",
  "attrPets": "Pets",
  "attrLanguages": "Languages",
  "attrLanguagesPh": "Add a language",
  "attrEducation": "Education",
  "attrReligion": "Religion",
  "attrReligionPh": "e.g. Muslim, Christian, none",
  "attrZodiac": "Zodiac",
  "attrRelationshipGoal": "Looking for",
  "attrWantsChildren": "Children",
  "attrClear": "Not set",
  "attrFacts": "Details",
  "attrBody_slim": "Slim",
  "attrBody_athletic": "Athletic",
  "attrBody_average": "Average",
  "attrBody_curvy": "Curvy",
  "attrBody_plus": "Plus size",
  "attrFreq_never": "Never",
  "attrFreq_sometimes": "Sometimes",
  "attrFreq_often": "Often",
  "attrFreq_socially": "Socially",
  "attrDiet_omnivore": "Omnivore",
  "attrDiet_vegetarian": "Vegetarian",
  "attrDiet_vegan": "Vegan",
  "attrDiet_halal": "Halal",
  "attrDiet_kosher": "Kosher",
  "attrDiet_other": "Other",
  "attrPets_none": "No pets",
  "attrPets_dog": "Dog",
  "attrPets_cat": "Cat",
  "attrPets_other": "Other",
  "attrEdu_high_school": "High school",
  "attrEdu_college": "College",
  "attrEdu_bachelors": "Bachelor's",
  "attrEdu_masters": "Master's",
  "attrEdu_phd": "PhD",
  "attrEdu_other": "Other",
  "attrZodiac_aries": "Aries",
  "attrZodiac_taurus": "Taurus",
  "attrZodiac_gemini": "Gemini",
  "attrZodiac_cancer": "Cancer",
  "attrZodiac_leo": "Leo",
  "attrZodiac_virgo": "Virgo",
  "attrZodiac_libra": "Libra",
  "attrZodiac_scorpio": "Scorpio",
  "attrZodiac_sagittarius": "Sagittarius",
  "attrZodiac_capricorn": "Capricorn",
  "attrZodiac_aquarius": "Aquarius",
  "attrZodiac_pisces": "Pisces",
  "attrGoal_serious": "Something serious",
  "attrGoal_casual": "Something casual",
  "attrGoal_friends": "New friends",
  "attrGoal_unsure": "Not sure yet",
  "attrKids_yes": "Want children",
  "attrKids_no": "Don't want children",
  "attrKids_maybe": "Maybe someday",
  "attrKids_have": "Have children",
  "locEnterPlace": "Enter country & city",
  "locPlaceTitle": "Where are you?",
  "locPlaceHint": "Pick your country and city — we'll set an approximate location so you can still match nearby.",
  "locCountry": "Country",
  "locCountryPh": "Select country",
  "locCity": "City",
  "locCityPh": "City (optional)",
  "locPlaceErr": "Couldn't set that location — try again.",
  "requests": "Requests",
  "requestAccept": "Accept",
  "requestDecline": "Decline",
  "requestWantsToChat": "wants to chat",
  "messageBeforeMatch": "Message before match",
  "messageComposeTitle": "Message {name}",
  "messageComposeHint": "Reach out before you match — they'll see your note and can reply to start a chat.",
  "messageComposePh": "Say something real…",
  "messageSendCta": "Send request",
  "messageRequestSent": "Request sent",
  "messageAlready": "You're already connected or have a pending request."
},
  fa: {
  "salon": "سالن",
  "kmAway": "{n} کیلومتر فاصله",
  "cityKmAway": "{city} · {n} کیلومتر فاصله",
  "locationHidden": "موقعیت پنهان است",
  "giftAfterMatch": "بعد از مچ‌شدن از چت هدیه بفرست",
  "matchPct": "{n}٪ تطابق",
  "onlineNow": "هم‌اکنون آنلاین",
  "deckEmptyTitle": "دسته خالی است",
  "deckEmptyNote": "سالن امشب ساعت ۲۰:۰۰ دوباره پر می‌شود.",
  "deckReset": "شروع دوباره",
  "salonEyebrow": "سالن امشب",
  "salonTitle1": "هفت نفر،",
  "salonTitle2": "انتخاب‌شده برای تو.",
  "salonSub": "بدون ورق‌زدن بی‌پایان — هر روز یک مجموعه دست‌چین.",
  "salonResets": "شروع دوباره تا {time}",
  "salonMore": "+{n} نفر دیگر",
  "salonUnlock": "باز شدن ساعت ۲۰:۰۰",
  "salonBlack": "FLM Black",
  "salonBlackBody": "هر هفت نفر را همین حالا ببین، به‌علاوه کسانی که تو را انتخاب کردند.",
  "orbitTap": "روی یکی در مدار خود بزن",
  "mutual": "دوطرفه است",
  "sayHiFirst": "اول تو سلام کن",
  "sendRose": "ارسال رز · ۰٫۵ TON",
  "matchIcebreaker": "یخ‌شکنِ او · دروغ را حدس بزن",
  "matchSharedTastes": "هر دو دوست دارید",
  "matchBreakIce": "یخ را بشکن · علایق او",
  "promptQuote": "«چهار زبان حرف می‌زنم، ماراتن دویده‌ام، از قهوه متنفرم.»",
  "promptOpt1": "۴ زبان",
  "promptOpt2": "ماراتن",
  "promptOpt3": "متنفر از قهوه",
  "likesTitle1": "{n} نفر",
  "likesTitle2": "تو را انتخاب کردند.",
  "likesSub": "{n} نفر امروز رایگان نمایان · بقیه با FLM Black",
  "likedYouTab": "لایکت کردند · {n}",
  "favoritesTab": "برگزیده‌ها · {n}",
  "rosesTab": "رزها · {n}",
  "blackBadge": "بلک",
  "revealAllCta": "دیدن هر {n} نفر — ۵ TON در ماه",
  "detailPrompt": "دو حقیقت و یک دروغ — حدس بزن",
  "tastesShared": "سلیقه‌ها · {n} مشترک",
  "giftsReceived": "هدایای دریافتی",
  "giftedTop": "جزو ۵٪ پرهدیه‌ی این هفته",
  "block": "مسدود",
  "report": "گزارش",
  "shareProfile": "اشتراک پروفایل",
  "photos": "عکس‌ها",
  "photoCover": "عکس اصلی",
  "closePhoto": "بستن",
  "prevPhoto": "عکس قبلی",
  "nextPhoto": "عکس بعدی",
  "mapTab": "نقشه",
  "eventsTab": "رویدادها",
  "cityName": "لیسبون",
  "mapNearby": "{city} · {n} نفر در نزدیکی",
  "ghostOff": "حالت روح خاموش",
  "ghostOn": "حالت روح روشن",
  "ghostHint": "حالت روح — ناشناس نقشه را می‌گردید",
  "crossedToday": "مسیرهای متقاطع امروز",
  "nNew": "{n} جدید",
  "crossedWhere": "هر دو در {place} بودید · {time}",
  "crossedPlace": "کافه ژانیس",
  "eventsEyebrow": "حضوری · {city}",
  "eventsTitle": "بیرون از گوشی قرار بگذارید.",
  "eventsSub": "رویدادهای اعضا · رزرو با TON، هنگام حضور بازپرداخت می‌شود",
  "hostEvent": "رویداد خودت را میزبانی کن",
  "evTagOpen": "شب آزاد",
  "evTagMixer": "دورهمی",
  "evTagBlack": "فقط FLM Black",
  "membership": "عضویت",
  "plansHero1": "آشنایی، انگار",
  "plansHero2": "با دعوت‌نامه.",
  "inStars": "استارز",
  "inTon": "TON",
  "inUsd": "≈ دلار",
  "goPlan": "فعال‌سازی {plan}",
  "payRail": "پرداخت با TON · USDT · BTC · ETH · استارز تلگرام",
  "mostChosen": "محبوب‌ترین انتخاب",
  "savePct": "{pct}٪ صرفه‌جویی",
  "billMonthly": "ماهانه",
  "billYearly": "سالانه",
  "mo": "ماه",
  "yr": "سال",
  "perYear": "۱ سال",
  "perMonth": "۱ ماه",
  "upgradeLabel": "ارتقا",
  "upgradeTo": "ارتقا به {plan}",
  "renewHero1": "اشتراک شما،",
  "renewHero2": "تمدید یا ارتقا.",
  "topTierNote": "روی بالاترین پلن هستید — هر زمان می‌توانید تمدید کنید.",
  "perkFreeLikes": "۳۰ لایک در روز",
  "perkFreeSpark": "۱ اسپارک در روز",
  "perkFreeMatch": "مچ و گفتگوی رایگان",
  "unlockPlan": "فعال‌سازی {plan}",
  "orStars": "یا {n} ★ استارز",
  "whatChanges": "چه چیزی عوض می‌شود",
  "freeTier": "رایگان",
  "cmpLikes": "لایک روزانه",
  "cancelNote": "هر زمان لغو کنید · رسید آن‌چین در کیف‌پول شما",
  "payTon": "TON · تون‌کیپر",
  "subTon": "TON Connect · UQB7…kT3v · موجودی 8.2 TON",
  "subStars": "{n} ★ · پرداخت داخل تلگرام",
  "subUsdt": "TRC-20 / جتون TON",
  "subBtc": "لایتنینگ",
  "subEth": "مین‌نت",
  "confirmTonkeeper": "تأیید در تون‌کیپر",
  "payWithStars": "پرداخت با استارز تلگرام",
  "connectWallet": "اتصال کیف‌پول",
  "payTonAmount": "پرداخت {amt} TON",
  "tonConnectHint": "کیف‌پول TON خود را وصل کن تا داخل اپ پرداخت کنی — تون‌کیپر، کیف‌پول تلگرام و بیشتر.",
  "tonWalletLinked": "کیف‌پول وصل شد — پرداخت را در کیف‌پولت تأیید کن.",
  "payManually": "اسکن QR · پرداخت دستی",
  "qrScanHint": "با هر کیف‌پول TON اسکن کن یا آدرس را کپی کن. به‌طور خودکار تأیید می‌شود.",
  "payCancelled": "پرداخت لغو شد — دوباره تلاش کن.",
  "payAmount": "پرداخت {amt} {coin}",
  "payViaLightning": "پرداخت با لایتنینگ",
  "qrNote": "یا از هر کیف‌پولی اسکن و پرداخت کنید — تأییدیه از طریق {bot} در چت می‌آید.",
  "nonCustodial": "بدون امانت‌سپاری · اشتراک قرارداد هوشمند، هر زمان لغوشدنی",
  "hubProfileComplete": "پروفایل {pct}٪ کامل",
  "hubStatLikes": "لایک",
  "hubStatMatches": "مچ",
  "hubStatGifts": "هدیه",
  "hubPremiumName": "پرمیوم",
  "hubPremiumSub": "ببین چه کسانی لایکت کرده‌اند · پرداخت با TON",
  "hubGoPremium": "پرمیوم شو",
  "hubGoPremiumSub": "ببین چه کسانی لایکت کرده‌اند، لایک نامحدود و بیشتر",
  "hubFromTon": "از {n} TON",
  "hubPremiumActive": "فعال",
  "premiumBadge": "پرمیوم",
  "premiumBadgeFallback": "ویژه",
  "comingSoon": "به‌زودی",
  "mpEyebrow": "عضویت",
  "mpTitlePremium": "عضویت تو",
  "mpTitleFree": "پرمیوم شو",
  "mpStatusActive": "فعال",
  "mpDaysLeft": "{n} روز باقی‌مانده",
  "mpDayLeft": "۱ روز باقی‌مانده",
  "mpExpires": "تمدید در {date}",
  "mpExpiresFree": "بدون اشتراک فعال",
  "mpPerksTitle": "چه چیزی دریافت می‌کنی",
  "mpLimitsTitle": "محدودیت‌های تو",
  "mpFreeSub": "لایک نامحدود، دیدن کسانی که لایکت کرده‌اند و بیشتر را باز کن.",
  "mpUnlimited": "نامحدود",
  "mpLikesUnlimited": "لایک نامحدود",
  "mpLikesFree": "{n} لایک در روز",
  "mpMessagesUnlimited": "پیام نامحدود",
  "mpMessagesFree": "{n} پیام در روز",
  "mpSuperLikesUnlimited": "جرقهٔ نامحدود",
  "mpSuperLikesFree": "{n} جرقه در روز",
  "mpSeeLikers": "ببین چه کسانی لایکت کرده‌اند",
  "mpSeeLikersFree": "لایک‌ها تا زمان مچ پنهان است",
  "mpRewind": "بازگرداندن آخرین ورق",
  "mpRewindFree": "بدون بازگرداندن",
  "mpBoost": "بوست {n} دقیقه‌ای",
  "mpRenew": "تمدید / تمدید اشتراک",
  "mpUpgrade": "پرمیوم شو",
  "mpUpgradeHigher": "ارتقا به سطح بالاتر",
  "hubEditPhotos": "ویرایش عکس‌ها و صدا",
  "hubEditPhotosSub": "{n} عکس · معرفی صوتی روشن",
  "hubVerification": "تأیید هویت",
  "hubVerificationSub": "بررسی چهره انجام شد",
  "hubPrivacy": "حریم خصوصی و حالت روح",
  "hubPrivacySub": "فقط برای مچ‌ها قابل مشاهده",
  "hubLanguageSub": "فارسی · English در دسترس",
  "hubWalletSub": "TON Connect · UQ…x4F2",
  "hubTon": "{n} TON",
  "messages": "پیام‌ها",
  "typing": "در حال نوشتن…",
  "onlineMatch": "آنلاین · {pct}٪ تطابق",
  "icebreakerGuessed": "یخ‌شکن · دروغ را حدس زدی",
  "ibOptLanguages": "۴ زبان",
  "ibOptMarathon": "ماراتن",
  "ibOptCoffee": "از قهوه بدش می‌آید",
  "ibCorrect": "درست — در واقع عاشق قهوه است. +۱ جرقه ⚡",
  "giftSentName": "{gift} ارسال شد",
  "tonOnChain": "{amount} تون · روی زنجیره",
  "seen": "دیده شد",
  "giftsEyebrow": "هدیه‌ها · روی زنجیره",
  "giftShopTitle": "با TON بگو.",
  "giftShopSub": "هدیه‌های کلکسیونی که در کیف پولش مینت می‌شود — برای همیشه نگه‌شان می‌دارد.",
  "sendingTo": "ارسال {gift} به {name}",
  "mintedNote": "مینت به‌صورت NFT · پیام ضمیمه می‌شود",
  "send": "ارسال",
  "giftRose": "رز",
  "giftChampagne": "شامپاین",
  "giftDiamond": "الماس",
  "giftMeteor": "شهاب‌سنگ",
  "tipTon": "انعام با TON",
  "pollTitle": "{name} یک نظرسنجی ساخت",
  "pollSub": "«قرار اول: گالری یا غذای خیابانی؟» · برای دیدن جوابش رأی بده",
  "hubBoost": "بوست",
  "hubBoostSub": "۳۰ دقیقه اول دیده شو",
  "hubBoostActiveSub": "در ابتدای دسته‌ای",
  "hubBoostActive": "فعال",
  "hubBoostUntil": "بوست شد — تا {time} اول دیده می‌شوی",
  "boostBuyEyebrow": "بوست",
  "boostBuyTitle": "برو ابتدای صف",
  "boostBuySub": "۳۰ دقیقه در بالای دستهٔ همه دیده شو — یک بوست یک‌بار مصرف، نه اشتراک.",
  "hubBoostFreeLeft": "{n} از {m} بوست رایگان باقی مانده · بازنشانی {when}",
  "hubBoostNoneLeft": "بوست‌های رایگان تمام شد · بازنشانی {when}",
  "hubBoostResetDays": "تا {n} روز دیگر",
  "hubBoostResetDay": "فردا",
  "hubBoostResetDate": "در {date}",
  "boostBuyOrWait": "بوست رایگان تمام شد — همین حالا یکی بخر، یا تا بازنشانی {when} صبر کن.",
  "rewind": "بازگرداندن",
  "rewindNothing": "چیزی برای بازگرداندن نیست",
  "rewindMatched": "هم‌دیگر را پسندیده‌اید — قابل بازگرداندن نیست",
  "sparksLeft": "{n} جرقه باقی‌مانده",
  "likesLeft": "{n} لایک امروز باقی‌مانده",
  "limitBackIn": "بازگشت تا {t}",
  "limitSoon": "تا لحظاتی دیگر",
  "dailyTitle": "جایزه روزانه",
  "dailyStreakN": "{n} روز پیاپی",
  "dailyClaim": "دریافت",
  "dailyNextIn": "بعدی تا {t}",
  "dailySparksReward": "+{n} جرقه",
  "dailyLikesReward": "+{n} لایک",
  "inviteTitle": "دعوت کن و جایزه بگیر",
  "inviteSub": "با پیوستن دوستت، هر دو {n} جرقه می‌گیرید",
  "inviteSubPremium": "با پیوستن دوستت، هر دو {n} روز {plan} می‌گیرید",
  "inviteStats": "{a} دعوت · {b} پیوسته",
  "inviteShare": "دعوت",
  "inviteShareText": "به من در FLM بپیوند 💘 — دوست‌یابی رایگان در تلگرام",
  "rewardPremium": "{n} روز {plan} باز شد!",
  "rewardSparks": "{n} جرقه رایگان!",
  "rewardPremiumSub": "امکانات پریمیومت فعال شد — لذت ببر.",
  "rewardSparksSub": "برو چند جرقه بفرست.",
  "rewardTrialTag": "هدیه خوش‌آمد",
  "rewardInviteTag": "جایزه دعوت",
  "rewardCta": "بزن بریم",
  "likesUnlimited": "لایک نامحدود",
  "outOfLikes": "لایک امروزت تمام شد — برای بیشتر ارتقا بده",
  "outOfSparks": "جرقه امروزت تمام شد — برای بیشتر ارتقا بده",
  "msgSent": "ارسال شد",
  "msgDelivered": "تحویل داده شد",
  "msgRead": "خوانده شد",
  "aboutYou": "درباره تو",
  "aboutYouSub": "همه اختیاری — هر چه می‌خواهی دیگران بدانند پر کن.",
  "attrHeight": "قد",
  "attrWeight": "وزن",
  "attrHeightPh": "سانتی‌متر",
  "attrWeightPh": "کیلوگرم",
  "attrUnitCm": "سانتی‌متر",
  "attrUnitKg": "کیلوگرم",
  "attrBodyType": "نوع اندام",
  "attrSmoking": "سیگار",
  "attrDrinking": "نوشیدنی",
  "attrExercise": "ورزش",
  "attrDiet": "رژیم غذایی",
  "attrPets": "حیوان خانگی",
  "attrLanguages": "زبان‌ها",
  "attrLanguagesPh": "یک زبان اضافه کن",
  "attrEducation": "تحصیلات",
  "attrReligion": "مذهب",
  "attrReligionPh": "مثلاً مسلمان، مسیحی، هیچ‌کدام",
  "attrZodiac": "ماه تولد",
  "attrRelationshipGoal": "به‌دنبال",
  "attrWantsChildren": "فرزند",
  "attrClear": "تعیین‌نشده",
  "attrFacts": "جزئیات",
  "attrBody_slim": "لاغر",
  "attrBody_athletic": "ورزشکاری",
  "attrBody_average": "متوسط",
  "attrBody_curvy": "پُرتر",
  "attrBody_plus": "درشت‌اندام",
  "attrFreq_never": "هرگز",
  "attrFreq_sometimes": "گاهی",
  "attrFreq_often": "اغلب",
  "attrFreq_socially": "در جمع",
  "attrDiet_omnivore": "همه‌چیزخوار",
  "attrDiet_vegetarian": "گیاه‌خوار",
  "attrDiet_vegan": "وگان",
  "attrDiet_halal": "حلال",
  "attrDiet_kosher": "کوشر",
  "attrDiet_other": "دیگر",
  "attrPets_none": "بدون حیوان خانگی",
  "attrPets_dog": "سگ",
  "attrPets_cat": "گربه",
  "attrPets_other": "دیگر",
  "attrEdu_high_school": "دبیرستان",
  "attrEdu_college": "کالج",
  "attrEdu_bachelors": "کارشناسی",
  "attrEdu_masters": "کارشناسی ارشد",
  "attrEdu_phd": "دکترا",
  "attrEdu_other": "دیگر",
  "attrZodiac_aries": "حمل",
  "attrZodiac_taurus": "ثور",
  "attrZodiac_gemini": "جوزا",
  "attrZodiac_cancer": "سرطان",
  "attrZodiac_leo": "اسد",
  "attrZodiac_virgo": "سنبله",
  "attrZodiac_libra": "میزان",
  "attrZodiac_scorpio": "عقرب",
  "attrZodiac_sagittarius": "قوس",
  "attrZodiac_capricorn": "جدی",
  "attrZodiac_aquarius": "دلو",
  "attrZodiac_pisces": "حوت",
  "attrGoal_serious": "رابطه جدی",
  "attrGoal_casual": "رابطه غیرجدی",
  "attrGoal_friends": "دوستان تازه",
  "attrGoal_unsure": "هنوز مطمئن نیستم",
  "attrKids_yes": "خواهان فرزند",
  "attrKids_no": "بدون تمایل به فرزند",
  "attrKids_maybe": "شاید روزی",
  "attrKids_have": "دارای فرزند",
  "locEnterPlace": "وارد کردن کشور و شهر",
  "locPlaceTitle": "کجا هستی؟",
  "locPlaceHint": "کشور و شهرت را انتخاب کن — یک موقعیت تقریبی تنظیم می‌کنیم تا باز هم بتوانی نزدیک‌ها را مچ کنی.",
  "locCountry": "کشور",
  "locCountryPh": "کشور را انتخاب کن",
  "locCity": "شهر",
  "locCityPh": "شهر (اختیاری)",
  "locPlaceErr": "تنظیم آن موقعیت ممکن نشد — دوباره تلاش کن.",
  "requests": "درخواست‌ها",
  "requestAccept": "پذیرفتن",
  "requestDecline": "رد کردن",
  "requestWantsToChat": "می‌خواهد گفتگو کند",
  "messageBeforeMatch": "پیام پیش از مچ",
  "messageComposeTitle": "پیام به {name}",
  "messageComposeHint": "پیش از مچ‌شدن سراغش برو — یادداشتت را می‌بیند و می‌تواند پاسخ دهد تا گفتگو شروع شود.",
  "messageComposePh": "یک حرف واقعی بزن…",
  "messageSendCta": "ارسال درخواست",
  "messageRequestSent": "درخواست ارسال شد",
  "messageAlready": "از قبل با هم در ارتباطید یا درخواستی در انتظار است."
},
};
